import GeoJSONReader from 'jsts/org/locationtech/jts/io/GeoJSONReader';
import RelateOp from 'jsts/org/locationtech/jts/operation/relate/RelateOp';
import Envelope from 'jsts/org/locationtech/jts/geom/Envelope';
import GeometryFactory from 'jsts/org/locationtech/jts/geom/GeometryFactory';
var operators = {
  '=': function _(a, b) {
    return a === b;
  },
  '~=': function _(a, b) {
    return Oskari.util.stringLike(a, b);
  },
  '≠': function _(a, b) {
    return a !== b;
  },
  '~≠': function _(a, b) {
    return !Oskari.util.stringLike(a, b);
  },
  '>': function _(a, b) {
    return a > b;
  },
  '<': function _(a, b) {
    return a < b;
  },
  '≥': function _(a, b) {
    return a <= b;
  },
  '≤': function _(a, b) {
    return a <= b;
  }
};
var propertiesMatchFilter = function propertiesMatchFilter() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var filter = arguments.length > 1 ? arguments[1] : undefined;
  if (!filter || !filter.attribute || !filter.operator) {
    // no filter defined
    return true;
  }
  var val = props[filter.attribute];
  if (typeof val === 'undefined' || val === null) {
    return false;
  }
  var isNumType = typeof val === 'number';
  var filterValNum = Number(filter.value);
  var filterVal = isNumType && !isNaN(filterValNum) ? filterValNum : filter.value;
  if (!isNumType && !filter.caseSensitive) {
    val = val.toUpperCase();
    filterVal = filterVal.toUpperCase();
  }
  return operators[filter.operator](val, filterVal);
};
export var filterFeaturesByAttribute = function filterFeaturesByAttribute(features) {
  var filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return features.filter(function (feature) {
    return propertiesMatchFilter(feature.properties || {}, filter);
  });
};
var filterFeaturesByJSTSGeometry = function filterFeaturesByJSTSGeometry(features, jstsGeometry) {
  var geomFilter = function geomFilter(feature) {
    return RelateOp.relate(jstsGeometry, reader.read(feature.geometry)).isIntersects();
  };
  return features.filter(geomFilter);
};
var reader = new GeoJSONReader();
export var filterFeaturesByGeometry = function filterFeaturesByGeometry(features, geometry) {
  var jstsGeometry = reader.read(geometry);
  return filterFeaturesByJSTSGeometry(features, jstsGeometry);
};
var GEOM_FACTORY = new GeometryFactory();
export var filterFeaturesByExtent = function filterFeaturesByExtent(features, extent) {
  if (!extent || extent.length < 4) {
    return features;
  }
  // https://github.com/bjornharrtell/jsts/blob/master/src/org/locationtech/jts/geom/Envelope.js
  // assumes that extent is [x1, x2, y1, y2], but OpenLayers uses [left, bottom, right, top]
  var extentAsJSTSGeometry = GEOM_FACTORY.toGeometry(new Envelope(extent[0], extent[2], extent[1], extent[3]));
  return filterFeaturesByJSTSGeometry(features, extentAsJSTSGeometry);
};

/**
 * @method getFilterAlternativesAsArray Arranges attribute filters based on AND & OR statements.
 * @param {WFSSetPropertyFilter} filters array from WFSSetPropertyFilter
 * @return {Array} An array of arrays containing attribute filters for each OR statement.
 */
export var getFilterAlternativesAsArray = function getFilterAlternativesAsArray(filters) {
  if (!filters || filters.length === 0) {
    return;
  }
  var alternatives = [[]];
  var attributeFilters = alternatives[0];
  filters.forEach(function (filter) {
    if (filter.attribute) {
      attributeFilters.push(filter);
    }
    if (!filter.boolean) {
      return;
    }
    if (filter.boolean === 'AND') {
      attributeFilters.push(filter);
    } else if (filter.boolean === 'OR') {
      attributeFilters = [];
      alternatives.push(attributeFilters);
    }
  });
  return alternatives;
};